/** A keyboard shortcut hint inside a button or a menu item ("Edit E", "Save ⌘S"): a
 *  hairline key cap in the text's own colour. */
import { Box } from '@mui/material';
import type { ReactNode } from 'react';

export function Kbd({ children }: { children: ReactNode }) {
  return (
    <Box
      component="kbd"
      sx={{
        ml: 0.75,
        px: 0.5,
        border: 1,
        borderColor: 'currentColor',
        borderRadius: 0.5,
        fontFamily: 'inherit',
        fontSize: 11,
        fontWeight: 600,
        lineHeight: 1.4,
        opacity: 0.75,
      }}
    >
      {children}
    </Box>
  );
}
